'use es6';

import http from 'hub-http/clients/apiClient';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
const LEVELS = 5;
const TIMEOUT = 15000;
/**
 * GET cosindex/api/v1/connections/:id/parents
 */

export function fetchParents(id, query = EMPTY_OBJECT) {
  return http.get(`cosindex/api/v1/connections/${id}/parents`, {
    query: Object.assign({
      levels: LEVELS,
      timeout: TIMEOUT,
      clienttimeout: TIMEOUT
    }, query || EMPTY_OBJECT)
  });
}
/**
 * GET cosindex/api/v1/connections/parents?id=1&id=2
 * @param  {Array.<Number>} ids
 */

export function bulkFetchParents(ids, query = EMPTY_OBJECT) {
  return http.get('cosindex/api/v1/connections/parents', {
    query: Object.assign({
      id: ids,
      levels: LEVELS,
      timeout: TIMEOUT,
      clienttimeout: TIMEOUT
    }, query || EMPTY_OBJECT)
  });
}